import type { PropsWithChildren } from 'react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import type { MessageKey } from '@/modules/localizations/translations/types';
import { Heading } from '@/modules/ui';

import * as felaRules from './SecretSection.rules';

export interface SecretSectionProps extends PropsWithChildren {
    title: MessageKey;
    customStyle?: typeof felaRules.sectionContainer;
    gap?: number;
}

export const SecretSection = ({ title, children, customStyle, gap = 1.5 }: SecretSectionProps) => {
    const { css } = useFela({ gap });

    return (
        <section className={css(felaRules.sectionContainer, customStyle)}>
            <Heading variant='h3' color='foregroundsPrimary'>
                <FormattedMessage id={title} />
            </Heading>
            <div className={css(felaRules.contentContainer)}>{children}</div>
        </section>
    );
};
